import { useTranslation } from 'react-i18next';

import { ADMIN_CLA_SETTINGS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditMaxCLA from './components/form/CreateEditMaxCLA';

import useColumnDefinitions from './hooks/useColumnDefinitions';
import useGetMaxCLASettingsTableData from './hooks/useGetMaxCLASettingsTableData';

const MaxCLASettings = () => {
  const { t } = useTranslation();
  const { convertedData, isFetching } = useGetMaxCLASettingsTableData();
  const columnDefinitions = useColumnDefinitions();

  const { mutate: handleDeleteClick } = useDeleteById(ADMIN_CLA_SETTINGS, [
    'maxCLASettings'
  ]);
  
  return (
    <TableCRUDLayout
      FormComponent={CreateEditMaxCLA}
      rows={convertedData}
      loading={isFetching}
      columns={columnDefinitions}
      getRowId={(row) => row.claDateId}
      onDeleteClick={handleDeleteClick}
      confirmationTitle={t('max_buh.deleteMaxCLADialog.title')}
      confirmationBody={t('max_buh.deleteMaxCLADialog.body')}
    />
  );
};

export default MaxCLASettings;
